import styled from 'styled-components';
import { breakpoints } from 'theme';

const bg = '#fff5f5';
const border = '#e24b4a';
const text = '#9b1c1c';
const ctaBg = '#e24b4a';
const ctaText = '#ffffff';

export const BannerRoot = styled.div`
  position: sticky;
  top: 0;
  z-index: 1200;
  width: 100%;
  box-sizing: border-box;
  background: ${bg};
  border-bottom: 1px solid rgba(226, 75, 74, 0.35);
  color: ${text};
`;

export const BannerInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px 20px;
  padding: 10px 20px;
  max-width: 1400px;
  margin: 0 auto;
  box-sizing: border-box;
  width: 100%;

  @media ${breakpoints.downSmPlus} {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 36px;
    grid-template-areas:
      'accent close'
      'actions actions';
    align-items: start;
    padding: 12px 12px 12px 16px;
    gap: 10px 8px;
  }
`;

export const BannerAccent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
  flex: 1;

  @media ${breakpoints.downSmPlus} {
    grid-area: accent;
  }
`;

export const BannerBar = styled.span`
  flex-shrink: 0;
  width: 4px;
  align-self: stretch;
  min-height: 28px;
  border-radius: 2px;
  background: ${border};
`;

export const BannerCopy = styled.div`
  min-width: 0;
  text-align: left;
`;

export const BannerTitle = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  color: ${text};
  word-break: break-word;
`;

export const BannerBody = styled.p`
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: ${text};
  opacity: 0.88;
  word-break: break-word;
`;

export const BannerActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  @media ${breakpoints.downSmPlus} {
    grid-area: actions;
    width: 100%;
  }
`;

export const BannerCta = styled.button`
  appearance: none;
  border: none;
  cursor: pointer;
  background: ${ctaBg};
  color: ${ctaText};
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  padding: 10px 14px;
  border-radius: 8px;
  white-space: nowrap;

  &:hover {
    filter: brightness(0.95);
  }

  &:focus-visible {
    outline: 2px solid ${border};
    outline-offset: 2px;
  }

  @media ${breakpoints.downSmPlus} {
    flex: 1;
    min-width: 0;
    text-align: center;
    white-space: normal;
  }
`;

export const BannerSecondary = styled.button`
  appearance: none;
  border: 1px solid rgba(226, 75, 74, 0.35);
  cursor: pointer;
  background: transparent;
  color: ${text};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  padding: 10px 12px;
  border-radius: 8px;
  white-space: nowrap;

  &:hover {
    background: rgba(226, 75, 74, 0.06);
  }

  &:focus-visible {
    outline: 2px solid ${border};
    outline-offset: 2px;
  }

  @media ${breakpoints.downSmPlus} {
    flex: 1;
    min-width: 0;
    text-align: center;
    white-space: normal;
  }
`;

export const BannerCloseButton = styled.button`
  appearance: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 8px;
  background: rgba(226, 75, 74, 0.14);
  color: ${text};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  padding: 0;
  margin: 0;
  line-height: 0;
  position: relative;
  z-index: 1;

  svg {
    display: block;
    flex-shrink: 0;
  }

  &:hover {
    background: rgba(226, 75, 74, 0.24);
  }

  &:focus-visible {
    outline: 2px solid ${border};
    outline-offset: 2px;
  }

  @media ${breakpoints.downSmPlus} {
    grid-area: close;
    align-self: start;
    justify-self: end;
  }
`;

export const AppShell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100svh;
`;
